import React from 'react';
import './TopScroll.css';
function TopScroll() {
    return (
        
        <div>
            <a id="back-to-top" title="Go to Top" href="#">
                <i class="fas fa-chevron-up"></i>
            </a>
        </div>
    );
}

export default TopScroll;